import {
  Badge,
  // Box,
  Button,
  Flex,
  HStack,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Logo from "./Logo";

import { handleCTA } from "../../utils";
import Theme from "../../constants/Theme";
// import { useSmoothScroll } from "../../utils/smoothScroll";
// import { ANIMATION_CONSTANTS } from "../../constants/animations";

const Header = ({ minimal }: { minimal: boolean }) => {
  const bgButton = useColorModeValue(Theme.STYLES.DARK_BG_BUTTON, "gray.800");
  // const { scrollToSection } = useSmoothScroll();

  // const handleAnchorClick = (
  //   e: React.MouseEvent<HTMLAnchorElement>,
  //   sectionId: string
  // ) => {
  //   e.preventDefault();
  //   scrollToSection(sectionId, ANIMATION_CONSTANTS.SCROLL.OFFSET);
  // };

  return (
    <Flex
      as="header"
      justify="space-between"
      align="center"
      paddingX={{ base: 4, md: 6, lg: 10 }}
      py={4}
      position="sticky"
      top={0}
      zIndex={10}
      backdropFilter="blur(10px)"
      backgroundColor="rgba(255, 255, 255, 0.9)"
      boxShadow="md"
      borderBottom="1px solid"
      borderColor="gray.100"
    >
      <Link href="/" display="flex" justifyContent="center" alignItems="center">
        <Logo size="5xl" />
      </Link>

      {/* Main Navigation */}

      {!minimal && (
        <HStack
          spacing={8}
          display={{ base: "none", md: "flex" }}
          color="gray.600"
        >
          <Link
            href="/"
            fontWeight="medium"
            position="relative"
            _after={{
              content: '""',
              position: "absolute",
              width: "100%",
              transform: "scaleX(0)",
              height: "2px",
              bottom: "-4px",
              left: "0",
              backgroundColor: "teal.500",
              transformOrigin: "bottom right",
              transition: "transform 0.3s ease-out",
            }}
            _hover={{
              _after: {
                transform: "scaleX(1)",
                transformOrigin: "bottom left",
              },
              color: "teal.500",
            }}
          >
            Home
          </Link>
          <Link
            href="/pricing"
            fontWeight="medium"
            position="relative"
            _after={{
              content: '""',
              position: "absolute",
              width: "100%",
              transform: "scaleX(0)",
              height: "2px",
              bottom: "-4px",
              left: "0",
              backgroundColor: "teal.500",
              transformOrigin: "bottom right",
              transition: "transform 0.3s ease-out",
            }}
            _hover={{
              _after: {
                transform: "scaleX(1)",
                transformOrigin: "bottom left",
              },
              color: "teal.500",
            }}
          >
            Pricing
          </Link>
          <Link
            href="https://blog.weqiq.com"
            fontWeight="medium"
            position="relative"
            _after={{
              content: '""',
              position: "absolute",
              width: "100%",
              transform: "scaleX(0)",
              height: "2px",
              bottom: "-4px",
              left: "0",
              backgroundColor: "teal.500",
              transformOrigin: "bottom right",
              transition: "transform 0.3s ease-out",
            }}
            _hover={{
              _after: {
                transform: "scaleX(1)",
                transformOrigin: "bottom left",
              },
              color: "teal.500",
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Blog
          </Link>
          <Flex align="center">
            <Badge
              ml={1}
              colorScheme="green"
              fontSize="0.7em"
              borderRadius="full"
              px={2}
            >
              Highly Secure
            </Badge>
          </Flex>
        </HStack>
      )}

      <HStack spacing={4}>
        <Badge
          display={{ base: "none", lg: "flex" }}
          colorScheme="purple"
          variant="subtle"
          py={1}
          px={3}
          borderRadius="full"
          fontSize="xs"
          alignItems="center"
        >
          AI First Platform For Doctors
        </Badge>
        <Link
          as="button"
          onClick={() => handleCTA("login")}
          fontWeight="medium"
          display={{ base: "none", sm: "block" }}
        >
          <Text color="gray.600">Log in</Text>
        </Link>
        <Button
          bg={bgButton}
          px={6}
          borderRadius="full"
          _hover={{ transform: "translateY(-2px)", boxShadow: "md" }}
          transition="all 0.2s"
          onClick={() => handleCTA("signup")}
        >
          <Text style={Theme.STYLES.GRADIENT_TEXT}>Get Started</Text>
        </Button>
      </HStack>
    </Flex>
  );
};

export default Header;
